import { makeAutoObservable, observable } from "mobx";
import GeneralStore from "./common";
import AuthStore from "../modules/auth/store";
import MenuStore from "../modules/menu/store/menu";
import ConstantsStore from "./constantsRegistry";
import ClientsStore from "../modules/clients/pages/client/store";
import CouponsStore from "../modules/coupons/store";
import GeneralMenuStore from "../modules/menu/store/generalMenuStore";
import BookingMenuStore from "../modules/menu/store/booking";
import ModifiersSetsStore from "../modules/menu/store/modifiersSets";
import TranslationStore from "../common/components/translation/TranslationStore";




const generalStore = new GeneralStore();
const authStore = new AuthStore();
const menuStore = new MenuStore();
const bookingStore = new BookingMenuStore();
const generalMenuStore = new GeneralMenuStore();
const constantsStore = new ConstantsStore();
const clientsStore = new ClientsStore();
const couponsStore = new CouponsStore();
const modifiersSetsStore = new ModifiersSetsStore();
const translationStore = new TranslationStore();


interface IStores {
    generalStore: GeneralStore,
    authStore: AuthStore,
    menuStore: MenuStore,
    constantsStore: ConstantsStore,
    clientsStore: ClientsStore,
    couponsStore: CouponsStore,
    bookingStore: BookingMenuStore,
    generalMenuStore: GeneralMenuStore,
    modifiersSetsStore: ModifiersSetsStore,
    translationStore: TranslationStore;

}

export class RootStore {
    @observable
    generalStore: GeneralStore;
    authStore: AuthStore;
    menuStore: MenuStore;
    bookingStore: BookingMenuStore;
    generalMenuStore: GeneralMenuStore;
    constantsStore: ConstantsStore;
    //onlineSalesStore: OnlineSalesStore;
    clientsStore: ClientsStore;
    couponsStore: CouponsStore;
    modifiersSetsStore: ModifiersSetsStore;
    translationStore: TranslationStore;

    constructor(stores: IStores) {
        makeAutoObservable(this);
        this.generalStore = stores.generalStore;
        this.authStore = stores.authStore;
        this.menuStore = stores.menuStore;
        this.bookingStore = stores.bookingStore;
        this.generalMenuStore = stores.generalMenuStore;
        this.constantsStore = stores.constantsStore;
        //this.onlineSalesStore = stores.onlineSalesStore;
        this.clientsStore = stores.clientsStore;
        this.couponsStore = stores.couponsStore;
        this.modifiersSetsStore = stores.modifiersSetsStore;
        this.translationStore = stores.translationStore;
    }
}

export const stores = {
    generalStore,
    authStore,
    menuStore,
    constantsStore,
    bookingStore,
    generalMenuStore,
    //onlineSalesStore,
    clientsStore,
    couponsStore,
    modifiersSetsStore,
    translationStore
};

const rootStore = new RootStore(stores);
export default rootStore
